import React from 'react'
import AuthContainer from '../../Containers/Auth/auth'

const Auth = () => {
  return (
    <AuthContainer />
  )
}

export default Auth